// extracted by mini-css-extract-plugin
module.exports = {"announcementIcon":"antd-pro-components-latest-update-icon-styles-announcementIcon"};